/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/containers/TrackPage/LearningPageSidebar.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const LEARNING_PAGE_SIDEBAR_FULL_WIDTH = 320;
const LEARNING_PAGE_SIDEBAR_REDUCED_WIDTH = 200;
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/containers/TrackPage/LearningPageSidebar.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
const LearningPageSidebar = ({
  backgroundColor,
  children,
  id,
  withSubNav
}) => {
  const {
    isLaptop
  } = useMediaQuery();
  const sidebarWidth = isLaptop ? LEARNING_PAGE_SIDEBAR_REDUCED_WIDTH : LEARNING_PAGE_SIDEBAR_FULL_WIDTH;
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: backgroundColor,
    borderColor: "border-core-subtle",
    borderRadius: "300",
    borderStyle: "solid",
    borderWidth: "100",
    id: id,
    maxInlineSize: `${sidebarWidth}px`,
    minBlockSize: `calc(100vh - ${withSubNav ? '126px' : '86px'})`,
    minInlineSize: `${sidebarWidth}px`,
    overflow: "hidden",
    position: "relative",
    children: /*#__PURE__*/_jsx(View, {
      inset: "0",
      overflowY: "auto",
      position: "absolute",
      children: children
    })
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/containers/TrackPage/LearningPageSidebar.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default LearningPageSidebar;